import { render, staticRenderFns } from "./CodingLogs.vue?vue&type=template&id=1146653c&scoped=true&"
import script from "./CodingLogs.vue?vue&type=script&lang=js&"
export * from "./CodingLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1146653c",
  null
  
)

export default component.exports